import MasterService from "./MasterService";

const PaymentService = {
    ...MasterService,

    getPaymentListing(params: object) {
        return this.post('/recon/getReconList', params)
    },
}

export default PaymentService;